import { Media } from '@shared-features/models';

function getMediaToFileData(media: Media): [any[], string, any] {
  const fileName = media.url.replace(/(.*)(\/.*\..*$)/, (match, g1, g2, offset, wholeString, groups) => {
    return g2.replace(/^\//, '');
  });

  return [
    [],
    fileName,
    { lastModified: media.updatedAt || media.createdAt, type: media.mimetype },
  ];
}

export class FileWithMedia extends File {
  constructor(public media: Media) {
    super(...getMediaToFileData(media));
  }
}


